<template>
  <wrap-container>
    <select-options
      label="Producto"
      title="¿Qué producto o servicio te interesa adquirir?"
    />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SelectOptions from "@/components/SelectOptions";

export default {
  name: "AdquisicionPedidosServicios",
  components: {
    WrapContainer,
    SelectOptions
  }
};
</script>

<style scoped></style>
